import { TemplateTypes } from "../../_helpers";


export const getTemplateTypes = (t) => {
    return [
        // { label: t("communication.type.0"), value: TemplateType.Correspondence.toString() },
        { label: t("template.type.1"), value: TemplateTypes.Email },
        { label: t("template.type.2"), value: TemplateTypes.Document },
    ];
};